import type { MRT_ColumnDef } from "mantine-react-table";

import {
    createDateColumn,
    createStringColumn,
    normalizeStringArray,
} from "../MetadataDocuments/columns/columnHelpers";
import type { FeedbackSchema } from "./types";

const namespace = "cts_user_chat";

export const metadataFeedbackColumns: MRT_ColumnDef<FeedbackSchema>[] = [
    createDateColumn<FeedbackSchema>({
        namespace,
        field: "timestamp",
        header: "Timestamp",
        accessor: (row) => row?._source?.timestamp,
        overrides: {
            accessorKey: "_source.timestamp",
        },
    }),
    createStringColumn<FeedbackSchema>({
        namespace,
        field: "question",
        header: "Question",
        accessor: (row) => row?._source?.question ?? "",
        overrides: {
            accessorKey: "_source.question",
        },
    }),
    createStringColumn<FeedbackSchema>({
        namespace,
        field: "cts_answer.feedback_type",
        header: "User Feedback Type",
        accessor: (row) => row?._source?.cts_answer?.feedback_type ?? "",
        overrides: {
            accessorKey: "_source.cts_answer.feedback_type",
        },
    }),
    createStringColumn<FeedbackSchema>({
        namespace,
        field: "evaluations.sme.feedback_type",
        header: "SME Feedback Type",
        accessor: (row) => row?._source?.evaluations?.sme?.feedback_type ?? "",
        overrides: {
            accessorKey: "_source.evaluations.sme.feedback_type",
        },
    }),
    createStringColumn<FeedbackSchema>({
        namespace,
        field: "org_code",
        header: "Organization",
        accessor: (row) => row?._source?.org_code ?? "",
        overrides: {
            accessorKey: "_source.org_code",
            size: 250,
        },
    }),
    createStringColumn<FeedbackSchema>({
        namespace,
        field: "request_options.datasources",
        header: "Datasources",
        accessor: (row) => normalizeStringArray(row?._source?.request_options?.datasources, ""),
        fallback: "",
        overrides: {
            accessorKey: "_source.request_options.datasources",
            size: 250,
        },
    }),
    createStringColumn<FeedbackSchema>({
        namespace,
        field: "request_options.product_line",
        header: "Product Line",
        accessor: (row) => row?._source?.request_options?.product_line ?? "",
        fallback: "",
        overrides: {
            accessorKey: "_source.request_options.product_line",
            size: 250,
        },
    }),
    createStringColumn<FeedbackSchema>({
        namespace,
        field: "request_options.memory_enabled",
        header: "Memory Enabled",
        accessor: (row) => {
            const value = row?._source?.request_options?.memory_enabled;
            if (typeof value === "string") {
                return value.toLowerCase() === "true" ? "Yes" : "No";
            }
            return value ? "Yes" : "No";
        },
        overrides: {
            accessorKey: "_source.request_options.memory_enabled",
        },
    }),
    createStringColumn<FeedbackSchema>({
        namespace,
        field: "origin",
        header: "Origin",
        accessor: (row) => row?._source?.origin ?? "",
        overrides: {
            accessorKey: "_source.origin",
            size: 250,
        },
    }),
];
